import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import clsx from 'clsx';

import { AppDispatch } from '../../../redux/reducer/store';
import { actionGetSingleVacancy } from '../../../redux/action/recruiting/actionVacancy';
import { reducerSingleVacancyIV, reducerSort } from '../../../redux/reducer/recruiting/reducers/reducerSingleVacancy';
import { reducerHeaderBtn } from '../../../redux/reducer/userReports/reducers/userReports'
import TableVacantRoutesListNotModal from './TableVacantRoutesListNotModal';
import { formatDateWithDots } from '../../../utils/formatDate';
import Loader from '../../custom/loader/loader';
import LeftForm from "./blocks/LeftForm";
import RightForm from "./blocks/RightForm";
import VacancyToast from "./blocks/VacancyToast";

import { EventItem, HistoryProps } from "../../../types/interfaces"

import '../../table/table.scss';
import styles from './recruiting.module.scss';

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableSingleVacancy: FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const [isPending, setIsPending] = useState<boolean>(true);
    const { isOpenSidebar } = useSelector((state: any) => state.user.user);
    const { claims } = useSelector((state: any) => state.user.user.data);
    const { inputValues, data, options } = useSelector(
        (state: any) => state.recruiting.singleVacancy
    );

    const {
        formData,
        history,
        routes,
    } = data;

    let showBtn = false
    if (inputValues && (inputValues.type === 'ON_ROUTE' || inputValues.type === 'PARTIAL_ROUTE')) {
        showBtn = true
    }
    const editVacancy = claims.includes('admin') || claims.includes('recruiting:vacancy:edit');
    const typeSelect = formData && formData?.types.find((el: string) => el.hasOwnProperty(inputValues.type));
    const scheduleSelect = formData?.schedule.find((el: string) => {
        return el.hasOwnProperty(inputValues.scheduleExt) || '';
    });
    const statusSelect = inputValues.formData?.status.find((el: string) => el.hasOwnProperty(inputValues.status)) || '';
    const nameSelect = formData && Object.values(typeSelect)[0];
    const scheduleExtSelect = formData && scheduleSelect ? Object.values(scheduleSelect)[0] as string : null;
    const statusName = inputValues && inputValues.formData && Object.values(statusSelect)[0];
    const selectChange = (event: EventItem, name: string) => {
        if (data[name] === event.value || (data[name] === undefined && !event.value)) {
            dispatch(reducerSort(false))
        } else {
            dispatch(reducerSort(true))
        }
        if (!event.value) {
            const updatedInputValues = { ...inputValues };
            delete updatedInputValues[name];
            dispatch(reducerSingleVacancyIV(updatedInputValues));
        } else {
            if ((event.value[0] === 'LOST_ROUTE' && name === 'type' && inputValues.type !== 'LOST_ROUTE') && routes.value) {
                dispatch(reducerHeaderBtn({ purpose: 'lostVacancyRoutes', title: 'Смена типа вакансии.', open: true }));
                dispatch(
                    reducerSingleVacancyIV({
                        ...inputValues,
                        [name]: event.value[0],
                        editType: inputValues.routes[0] !== null
                    })
                );
            } else {
                dispatch(
                    reducerSingleVacancyIV({
                        ...inputValues,
                        [name]: name === 'projects' ? event.value : name === 'virtualSupervisorsExt' ? [{ id: event.value[0] }] : event.value[0],
                    })
                );
            }
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        if (data[name] === undefined && value === '') {
            dispatch(reducerSort(false));
        } else if (name === 'salaryExt' && data[name] === parseFloat(value)) {
            dispatch(reducerSort(false));
        } else if (name !== 'salaryExt' && data[name] === value) {
            dispatch(reducerSort(false));
        } else {
            dispatch(reducerSort(true));
        }

        if (value === '') {
            const updatedInputValues = { ...inputValues };
            if (name === 'workloadExt') {
                updatedInputValues.workloadExt = 0
            } else {
                delete updatedInputValues[name];
            }
            dispatch(reducerSingleVacancyIV(updatedInputValues));
        } else {
            if (name === 'workloadExt') {
                const timeArray = value.split(':');
                const totalMinutes = (parseInt(timeArray[0]) * 60) + parseInt(timeArray[1]);
                dispatch(reducerSingleVacancyIV({ ...inputValues, workloadExt: totalMinutes }));
            } else {
                dispatch(reducerSingleVacancyIV({ ...inputValues, [name]: value }));
            }
        }
    };
    useEffect(() => {
        setIsPending(true);
        dispatch(actionGetSingleVacancy(id)).then(() => {
            setIsPending(false);
        });
    }, [dispatch, id]);
    return (
        <>
            <div className='loader__wrapper'>{isPending && <Loader />}</div>
            <div
                className={clsx(
                    JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
                    isOpenSidebar &&
                    'customerSingle__report_activeTable',
                    !isOpenSidebar && 'customerSingle__report_closedTable',
                    'vacancy_create_table'
                )}
            >
                <VacancyToast />
                <div className={styles.tableWrapper}>
                    <div className={styles.midSectionWrapper}>
                        <h1 className={styles.title}>Вакансия № {id}</h1>
                    </div>
                    <div className={styles.midSectionWrapper} >
                        <LeftForm
                            inputValues={inputValues}
                            nameSelect={nameSelect}
                            statusName={statusName}
                            selectChange={selectChange}
                            handleInputChange={handleInputChange}
                            options={options}
                            data={data}
                            editVacancy={editVacancy}
                        />

                        <RightForm
                            inputValues={inputValues}
                            nameSelect={nameSelect}
                            statusName={statusName}
                            selectChange={selectChange}
                            handleInputChange={handleInputChange}
                            options={options}
                            scheduleExtSelect={scheduleExtSelect}
                            data={data}
                            editVacancy={editVacancy}
                        />

                        <div className={clsx(styles.halfBlock, 'history_title')}>
                            <div>
                                <span className='section__title'>История</span>
                            </div>
                            <table>
                                <thead style={{ top: '-1px' }}>
                                    <tr>
                                        <th>Дата</th>
                                        <th>Изменил</th>
                                        <th>Поле</th>
                                        <th>Старое значение</th>
                                        <th>Новое значение</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {history && history.length > 0 &&
                                        history.map((el: HistoryProps, index: number) => {
                                            const fieldMappings: { [key: string]: string } = {
                                                'Адрес': 'Список адресов',
                                                'URL Адрес': 'Ссылка на вакансию',
                                                'Комментарий': 'Комментарий ОПП',
                                                'Метро': 'Метро/район',
                                            };
                                            const fieldValue = Object.values(el.field)[0] as string;
                                            const name = fieldMappings[fieldValue] || Object.values(el.field)[0];
                                            const nameContract = el.changer === 'Система' ? 'Количество контрактов (из маршрута)' : 'Количество контрактов';
                                            const timeValue = (item: number) => {
                                                const hour = item && item >= 60 ? item / 60 < 10 ? `0${Math.floor(item / 60)}` : `${Math.floor(item / 60)}` : '00';
                                                const minuts = item && item > 0 ? item % 60 < 10 ? `0${Math.floor(item % 60)}` : `${Math.floor(item % 60)}` : '00';
                                                return `${hour}:${minuts}`
                                            }
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr key={index}>
                                                        <td>{formatDateWithDots(el.date)}</td>
                                                        <td>{el.changer}</td>
                                                        <td>{el && name}</td>
                                                        <td>{el.old === 'null' ? '' : fieldValue === 'Длительность рабочего дня' ? timeValue(parseFloat(el.old)) : el.old}</td>
                                                        <td>{el.new === 'null' || el.new === 'false' ? '' : fieldValue === 'Длительность рабочего дня' ? timeValue(parseFloat(el.new)) : el.new}</td>
                                                    </tr>
                                                    {name === 'Контракты' && (
                                                        <tr key={`${index}-contracts`}>
                                                            <td>{formatDateWithDots(el.date)}</td>
                                                            <td>{el.changer}</td>
                                                            <td>{nameContract}</td>
                                                            <td>{!el.old ? '0' : el.old?.split(',').length}</td>
                                                            <td>{!el.new ? '0' : el.new?.split(',').length}</td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}

                                </tbody>
                            </table>
                        </div>
                    </div>

                    {((claims.includes('admin') || claims.includes('projects:routes:list')) && showBtn) &&
                        <>
                            <span className='section__title'>Маршруты</span>
                            <div style={{ height: '300px' }}>
                                <TableVacantRoutesListNotModal
                                    inVacancyPage={true}
                                    routes={routes.value}
                                />
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    );
};

export default TableSingleVacancy;
